import * as actionTypes from "../../Constants/locations/locationActionTypes";

const initialState = {
    edited: false,
    rowsCount: 0,
    showLoader: false,
    isClearFilters: false,
    locations: [],
    countries: [],
    timeZones: [],
    locationTypes: [],
    originalAllLocations: "",
    isAddNewLocation: false,
    isDeleteFeatureEnabled: false
}


const allLocations = ( state = initialState , action) => { 
    switch(action.type) {
        case actionTypes.FETCH_ALL_LOCATIONS:
            return {
                ...state,
                locations: action.payload.locationData.LocationModels,
                countries: action.payload.locationData.countries,
                timeZones: action.payload.locationData.timeZones,
                locationTypes: action.payload.locationData.branchTypes,
                originalAllLocations: JSON.stringify(action.payload.locationData.LocationModels),
                isDeleteFeatureEnabled: action.payload.locationData.isDeleteFeatureEnabled

            }
        case actionTypes.CLEAR_ALL_FILTERS:
            return {
                ...state,
                isClearFilters: action.payload.isClearFilters,
                locations: action.payload.allLocations,
                selectedUsers: {
                    ...state.selectedUsers,
                    selectedUsersIds: [],
                    selectedUsersStatus: []
                }
            };
        case actionTypes.ROWS_COUNT_AFTER_FILTER:
            return {
                ...state,
                rowsCount: action.payload.rowsCount
            };
        case actionTypes.SHOW_LOADER:
            return {
                ...state,
                showLoader: action.payload.showLoader
            }
        case actionTypes.IS_EDITED:
            return {
                ...state,
                edited: action.payload.edited,
            }
        case actionTypes.SAVE_EDITS:
            return {
                ...state,
                locations: action.payload.locationData,
                edited: false,
            }
        case actionTypes.DISCARD_CHANGES: {
            let originalLocations;
            try {
                originalLocations = JSON.parse(state.originalAllLocations);
            }
            catch (error) {
                console.error('Invalid JSON input:', error.message);
            }
            return {
                ...state,
                edited: false,
                mychangedRows: [],
                locations: originalLocations
            }
        }
        case actionTypes.ADD_NEW_LOCATION:
            return {
                ...state,
                isAddNewLocation: action.payload.isAddNewLocation
            };
        default :
            return state
    }
}

export default allLocations

